export default "__VITE_ASSET__DCaI73Zk__"